<template>
<div class="PageTopForm f89015cbd">
  <el-form :inline="true" :model="formInline" class="demo-form-inline" @submit.native.prevent>
    <slot name="form"></slot>
  </el-form>
  <div class="action-btn">
    <slot name="action"></slot>
  </div>
</div>
</template>

<script>
export default {
  name: 'PageTopForm',
  props: {},
  components: {},
  data () {
    return {
      formInline: {}
    }
  },
  computed: {
    name () {
      return this.data
    }
  },
  watch: {
    data (newValue, oldValue) {

    }
  },
  methods: {
  },
  filters: {}
}
</script>

<style lang="scss">
.PageTopForm.f89015cbd{
  width: 100%;
  height: 70px;
  background: #272829;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 32px;
  padding-right: 20px;
  box-sizing: border-box;
  margin-bottom: 20px;
  .el-form{
    display: flex;
    align-items: center;
    >div{
      display: flex;
    }
    .el-form-item{
      margin-bottom: 0;
      margin-right: 33px;
      .el-form-item__label{
        color: #ffffff;
        padding-right: 0px;
      }
      .el-form-item__content{
        width: 260px;
        .el-date-editor{
          width: 100%;
          height: 32px;
          margin-top: 4px;
          background-color: rgba(255, 255, 255, 0.1) !important;
          border: 1px solid rgba(55, 56, 57, 0) !important;
          .el-range-input{
            background-color: rgba(255, 255, 255, 0) !important;
            color: white !important;
            &::-webkit-input-placeholder {
              color: $font-color8 !important;
            }
          }
          .el-icon-date,.el-icon-circle-close{
            transform: translateY(-3px);
          }
          .el-range-separator{
            color: rgba(136, 136, 136, 0.73);
            transform: translateY(-4px);
          }
        }
      }
    }
    .search-btn{
      display: flex;
      align-items: center;
      >button{
        width: 60px;
      }
      >span{
        cursor: pointer;
        font-family: Source Han Sans SC;
        font-weight: 300;
        font-size: 14px;
      }
      >span:first-child{
        color: rgba(255, 255, 255, 1);
        margin-right: 20px;
      }
      >span:last-child{
        color: rgba(255, 255, 255, 0.4);
      }
    }
  }
}
</style>
